import { Controller } from "@hotwired/stimulus"

// Kontroler do testowania wyszukiwania w Noe::Db
export default class extends Controller {
  static targets = [
    "tableNameField",
    "qField",
    "searchInField",
    "sortField",
    "limitField",
    "offsetField",
    "fieldsField",
    "filtersField",
    "results",
    "count",
    "status",
    "urlDisplay",
  ]

  static values = {
    url: String,
  }

  connect() {
    this.updateUrlDisplay()
  }

  // Buduje URL z parametrami
  buildUrl() {
    const params = new URLSearchParams()

    if (this.hasTableNameFieldTarget && this.tableNameFieldTarget.value) {
      params.set("table_name", this.tableNameFieldTarget.value)
    }

    if (this.qFieldTarget.value) {
      params.set("q", this.qFieldTarget.value)
    }

    if (this.searchInFieldTarget.value) {
      params.set("search_in", this.searchInFieldTarget.value)
    }

    if (this.sortFieldTarget.value) {
      params.set("sort", this.sortFieldTarget.value)
    }

    if (this.limitFieldTarget.value) {
      params.set("limit", this.limitFieldTarget.value)
    }

    if (this.offsetFieldTarget.value && this.offsetFieldTarget.value !== "0") {
      params.set("offset", this.offsetFieldTarget.value)
    }

    if (this.fieldsFieldTarget.value) {
      params.set("fields", this.fieldsFieldTarget.value)
    }

    // Parse filters from textarea
    const filtersText = this.filtersFieldTarget.value.trim()
    if (filtersText) {
      filtersText.split("\n").forEach((line) => {
        const [key, ...valueParts] = line.split("=")
        if (key && valueParts.length > 0) {
          params.set(`filter[${key.trim()}]`, valueParts.join("=").trim())
        }
      })
    }

    const queryString = params.toString()
    return queryString ? `${this.urlValue}?${queryString}` : this.urlValue
  }

  // Aktualizuje wyświetlany URL
  updateUrlDisplay() {
    const url = this.buildUrl()
    this.urlDisplayTarget.textContent = url
  }

  // Wykonuje wyszukiwanie
  async search() {
    this.updateUrlDisplay()
    this.statusTarget.textContent = "Wyszukiwanie..."
    this.resultsTarget.textContent = ""
    this.countTarget.textContent = ""

    try {
      const url = this.buildUrl()
      const response = await fetch(url, {
        headers: {
          Accept: "application/json",
        },
      })

      const data = await response.json()

      if (response.ok) {
        this.resultsTarget.textContent = JSON.stringify(data, null, 2)
        this.countTarget.textContent = `${data.length} rekordów`
        this.statusTarget.textContent = "Gotowe"
      } else {
        this.resultsTarget.textContent = JSON.stringify(data, null, 2)
        this.countTarget.textContent = "Błąd"
        this.statusTarget.textContent = data.error || "Błąd zapytania"
      }
    } catch (error) {
      this.resultsTarget.textContent = error.message
      this.statusTarget.textContent = "Błąd połączenia"
    }
  }
}
